import { render, staticRenderFns } from "./carrierFrom.vue?vue&type=template&id=5675023c&scoped=true&"
import script from "./carrierFrom.vue?vue&type=script&lang=js&"
export * from "./carrierFrom.vue?vue&type=script&lang=js&"
import style0 from "./carrierFrom.vue?vue&type=style&index=0&id=5675023c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675023c",
  null
  
)

export default component.exports